/**
 * PDP: injeta vídeos da sequência da coleção principal (Namoro / Casamento).
 * Coleções: seção «Vídeos da coleção» editável no personalizador.
 * Home mantém sequência própria (Video Testimonials no index).
 */
(function () {
  const mount = document.querySelector('[data-andrade-home-videos]');
  if (!mount) return;

  const path = window.location.pathname;
  const isProduct = path.includes('/products/');
  const materialFamily = (mount.dataset.materialFamily || '').trim();
  const collectionHandle = (mount.dataset.collectionHandle || '').trim();
  const sectionInstanceId = (mount.dataset.sectionInstanceId || '').trim();

  const SECTION_BY_HANDLE = {
    'aliancas-namoro': 'collection_videos_namoro',
    'aliancas-casamento': 'collection_videos_casamento',
  };

  const sectionIdCache = new Map();

  const resolveSectionKey = () => {
    if (sectionInstanceId) return sectionInstanceId;
    if (collectionHandle && SECTION_BY_HANDLE[collectionHandle]) {
      return SECTION_BY_HANDLE[collectionHandle];
    }
    return '';
  };

  if (!isProduct) {
    mount.remove();
    return;
  }

  if (document.querySelector('.video-testimonials')) {
    mount.remove();
    return;
  }

  if (!collectionHandle) {
    mount.remove();
    return;
  }

  const sectionKey = resolveSectionKey();
  if (!sectionKey) {
    mount.remove();
    return;
  }

  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  const getPreviewThemeId = () => {
    const params = new URLSearchParams(window.location.search);
    return (params.get('preview_theme_id') || '').trim();
  };

  const withPreview = (url) => {
    const previewId = getPreviewThemeId();
    if (!previewId) return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}preview_theme_id=${encodeURIComponent(previewId)}`;
  };

  const loadStylesheet = () =>
    new Promise((resolve) => {
      const href = mount.dataset.carouselCss || '';
      if (!href) {
        resolve();
        return;
      }
      if (document.querySelector(`link[href="${href}"]`)) {
        resolve();
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = () => resolve();
      document.head.appendChild(link);
    });

  const loadSwatches = () =>
    new Promise((resolve) => {
      const src = mount.dataset.swatchesSrc || '';
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const loadScript = () =>
    new Promise((resolve) => {
      if (customElements.get('video-testimonials-carousel')) {
        resolve();
        return;
      }
      const existing = document.querySelector('script[src*="video-testimonials-carousel"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => resolve(), { once: true });
        return;
      }
      const s = document.createElement('script');
      s.src = mount.dataset.carouselSrc || '';
      if (!s.src) {
        resolve();
        return;
      }
      s.defer = true;
      s.onload = () => {
        s.dataset.loaded = 'true';
        resolve();
      };
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const fetchSectionsJson = async (sectionRequestId) => {
    const url = withPreview(
      `${root}collections/${encodeURIComponent(collectionHandle)}?sections=${encodeURIComponent(sectionRequestId)}`
    );
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return res.json();
  };

  const resolveTemplateSectionId = async () => {
    const cacheKey = `${collectionHandle}::${sectionKey}`;
    if (sectionIdCache.has(cacheKey)) {
      return sectionIdCache.get(cacheKey);
    }

    const pageRes = await fetch(
      withPreview(`${root}collections/${encodeURIComponent(collectionHandle)}`),
      { credentials: 'same-origin' }
    );
    if (!pageRes.ok) return '';

    const pageHtml = await pageRes.text();
    const escapedKey = sectionKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = pageHtml.match(
      new RegExp(`shopify-section-(template--\\d+__${escapedKey})`, 'i')
    );
    const fullId = match ? match[1] : '';
    if (fullId) {
      sectionIdCache.set(cacheKey, fullId);
    }
    return fullId;
  };

  const fetchCollectionVideosHtml = async () => {
    const templateSectionId = await resolveTemplateSectionId();
    const candidates = [];
    if (templateSectionId) candidates.push(templateSectionId);
    if (!candidates.includes(sectionKey)) candidates.push(sectionKey);

    for (const requestId of candidates) {
      const sections = await fetchSectionsJson(requestId);
      const html = sections?.[requestId];
      if (html && String(html).trim().length >= 50) {
        return String(html);
      }
    }

    return '';
  };

  const shouldPreserveScroll = () => {
    const hash = (window.location.hash || '').replace('#', '');
    return hash === 'md-pdp-ficha' || hash === 'md-pdp-descricao' || hash === 'md-pdp-detalhes';
  };

  const restoreScrollPosition = (savedY) => {
    window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  };

  const showMountError = () => {
    mount.classList.add('md-pdp__videos-mount--error');
    mount.setAttribute('aria-busy', 'false');
    mount.innerHTML =
      '<p class="md-pdp__videos-mount-msg">Não foi possível carregar os vídeos da coleção. Abra a coleção no personalizador e configure a seção <strong>Vídeos da coleção</strong>.</p>';
  };

  const afterInject = (sectionEl) => {
    const preserveScroll = shouldPreserveScroll();
    const savedY = preserveScroll ? window.scrollY : null;

    mount.remove();

    const carousels = sectionEl.querySelectorAll('video-testimonials-carousel');
    carousels.forEach((el) => {
      if (typeof customElements.upgrade === 'function') customElements.upgrade(el);
      if (typeof el.reloadSlides === 'function') el.reloadSlides();
    });

    const refresh = () => window.AndradeVideoCarousel?.refresh(sectionEl);

    refresh();
    [100, 300, 600, 1200, 2500].forEach((ms) => window.setTimeout(refresh, ms));

    sectionEl.querySelectorAll('video').forEach((video) => {
      video.addEventListener('loadeddata', refresh, { once: true });
      video.addEventListener('canplay', refresh, { once: true });
    });

    if (preserveScroll && savedY != null) {
      let cancelled = false;
      const cancelRestore = () => {
        cancelled = true;
      };

      window.addEventListener('wheel', cancelRestore, { once: true, passive: true });
      window.addEventListener('touchmove', cancelRestore, { once: true, passive: true });
      window.addEventListener(
        'keydown',
        (event) => {
          if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', ' ', 'Spacebar'].includes(event.key)) {
            cancelRestore();
          }
        },
        { once: true }
      );

      const restore = () => {
        if (cancelled) return;
        restoreScrollPosition(savedY);
      };

      restore();
      requestAnimationFrame(restore);
      [50, 150, 350].forEach((ms) => {
        window.setTimeout(restore, ms);
      });
    }
  };

  const insertSection = (sectionEl) => {
    const credibilityAnchor =
      document.querySelector('[data-md-pdp-credibility]') ||
      document.querySelector('.md-pdp-credibility');

    if (credibilityAnchor) {
      credibilityAnchor.insertAdjacentElement('afterend', sectionEl);
      return;
    }

    if (mount.parentNode) {
      mount.insertAdjacentElement('beforebegin', sectionEl);
      return;
    }

    mount.replaceWith(sectionEl);
  };

  const injectFromHtml = (html) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const sectionEl =
      wrapper.querySelector('.shopify-section, [id^="shopify-section-"]') ||
      wrapper.querySelector('.video-testimonials') ||
      wrapper.firstElementChild;
    if (!sectionEl) throw new Error('no section element');

    if (!sectionEl.querySelector('.video-testimonials')) {
      mount.remove();
      return;
    }

    insertSection(sectionEl);
    afterInject(sectionEl);
  };

  const loadVideos = async (attempt = 0) => {
    try {
      await Promise.all([loadStylesheet(), loadSwatches()]);
      await loadScript();

      const html = await fetchCollectionVideosHtml();
      if (!html) throw new Error('collection videos not found');

      injectFromHtml(html);
    } catch (_) {
      if (attempt < 3) {
        window.setTimeout(() => loadVideos(attempt + 1), 600 + attempt * 400);
        return;
      }
      showMountError();
    }
  };

  const start = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => loadVideos());
    } else {
      loadVideos();
    }
  };

  const schedule = () => {
    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          io.disconnect();
          start();
          return;
        }
      },
      { rootMargin: '500px 0px', threshold: 0.01 }
    );
    io.observe(mount);
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => schedule(), { timeout: 2500 });
  } else {
    window.setTimeout(schedule, 1);
  }
})();
